import { message } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { Button, CustomSelect, ModalTooltip } from "../../../components";
import { setDataTable } from "../../../redux/tableSlice/thunk.js";
import { COLGATEMONTECARGA, uploadColgateMontacargaCsv } from "../../../redux/VRT/thunks";

export const UpdateCampaing = ({ close }) => {
    const dispatch = useDispatch();
    const { proyects, proyectSelected } = useSelector((state) => state.vrlSlice);
    const [itemSelected, setSelectItem] = useState(proyectSelected._id);
    const [arrayLoad, setArrayLoad] = useState([]);
    const [rawCsvText, setRawCsvText] = useState("");

    const CSVToArray = (data, delimiter = ",", omitFirstRow = false) => {
        return data
            .slice(omitFirstRow ? data.indexOf("\n") + 1 : 0)
            .split("\n")
            .map((v) => v.split(delimiter));
    };

    const props = {
        name: "file",
        multiple: false,
        accept: ".csv",
        beforeUpload: (file) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                setRawCsvText(e.target.result);
                const arrayCsv = CSVToArray(e.target.result);
                setArrayLoad(arrayCsv);
                // console.log(itemSelected);
                message.success(`${file.name} cargado correctamente.`);
            };
            reader.readAsText(file);
            return false;
        },
        onDrop(e) {
            console.log("Dropped files", e.dataTransfer.files);
        },
    };

    return (
        <div className="w-full h-full flex items-center flex-col">
            <div className="w-full px-4">
                <div className="">
                    <p className="mb-2 text-xs font-medium text-[#9A9A9A] mt-4">
                        Los resultados de las sesiones en Inmersys VR Learning se actualizan automáticamente por medio de wi-fi. En caso que no sea
                        así, utiliza esta opción para subir manualmente los resultados.
                    </p>
                    <p className="mt-2 mb-1 text-base font-medium text-686868">Capacitación:</p>
                    {proyects.length > 0 && (
                        <CustomSelect
                            items={proyects}
                            value={proyects[0]._id}
                            label="Selecciona la capacitación donde subirás el archivo"
                            change={setSelectItem}
                        />
                    )}
                </div>
                <div className="flex h-7 items-center">
                    <p className="mr-2">Archivo:</p>
                    <ModalTooltip
                        title={`Este archivo debe de contener los resultados obtenidos de un Oculus. Para obtener más información acerca de 
                    transferir un archivo de un Oculus a Inmersys VR Training, consulta la sección de "Ayuda".`}
                        placement={"right"}
                        color={"#3366FF"}
                    />
                </div>
                <div className="h-[174px] mt-1">
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined className="text-3366FF" />
                        </p>
                        <p className="ant-upload-text">Selecciona o suelta un archivo en esta área para cargarlo.</p>
                        <p className="ant-upload-hint">Solo archivos .csv</p>
                    </Dragger>
                </div>
            </div>
            <div className="absolute  bottom-0 h-[48px] w-full flex justify-end items-center px-4">
                <Button
                    text="Cancelar"
                    isPrincipal={false}
                    onClick={() => {
                        close();
                    }}
                />
                <div className="w-4"></div>
                <Button
                    text="Subir"
                    isPrincipal={true}
                    onClick={() => {
                        if (COLGATEMONTECARGA.includes(itemSelected)) {
                            dispatch(uploadColgateMontacargaCsv({ csvText: rawCsvText, projectId: itemSelected }));
                        } else {
                            dispatch(setDataTable({ array: arrayLoad, projectId: itemSelected }));
                        }
                        close();
                    }}
                />
            </div>
        </div>
    );
};
